module.exports = __webpack_public_path__ + "img/jira.accce291.png";